<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/tool/adapt/page" getKey="rows" :columns="columns">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('chanpinbianma')">
            <el-input v-model="yt.conditions.materialCode"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <el-input v-model="yt.conditions.materialName"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1,beforeGet)" type="primary" plain="plain">
              {{ $t("sousuo") }}
            </el-button>
            <el-button @click="yt.clear((conditions = {toolId: $attrs.tool.id,adaptObjectType:0}))">{{ $t("chongzhi") }}</el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng', null, 'w1');" v-if="utils.checkPower('web_base_tool_adapt_product_add_button')" type="primary" v-burylog="{functionType: '用户行为', logType: '按钮点击', startData: {'s1': '工装台账-新增工装产品关系'}}">
          {{ $t("xinzeng") }}
        </el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="utils.checkPower('web_base_tool_adapt_product_update_button')">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row, 'w1');" :loading="yt.editObj.loading" v-burylog="{functionType: '用户行为', logType: '按钮点击', startData: {'s1': '工装台账-更新工装产品关系'}}">{{ $t("bianji") }} </el-button>
          </el-col>
          <el-col :span="0.1" v-if="utils.checkPower('web_base_tool_adapt_product_delete_button')">
            <el-button type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/tool/adapt/delete')" :loading="yt.editObj.loading" v-burylog="{functionType: '用户行为', logType: '按钮点击', startData: {'s1': '工装台账-删除工装模具关系'}}">{{ $t("shanchu") }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增/编辑表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'||yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('chanpinbianma/mingcheng')" required="required" v-if="yt.editObj.action == 'xinzeng'">
            <yi_cross_select :selectTitle="'code,name'" :component="'web_base_matter_list'" :max="1" :ids.sync="yt.editObj.materialId"></yi_cross_select>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('chanpinbianma')" v-if="yt.editObj.action == 'bianji'">
            <el-input disabled v-model="yt.editObj.material.code"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('chanpinmingcheng')" v-if="yt.editObj.action == 'bianji'">
            <el-input v-model="yt.editObj.material.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shipeileixing')">
            <yi_dictionary_select :type="'CUSTOMER_TOOL_ADAPT_TYPE'" :ids.sync="yt.editObj.adaptType"></yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('youxianji')" label-width="145px">
            <el-input v-model="yt.editObj.sort" oninput="value=value.replace(/^0|[^0-9]/g, '')"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t("quxiao") }}</el-button>
          <el-button v-if="yt.editObj.action == 'xinzeng'" @click="yt.req('POST', '/web/tool/adapt/create',beforeAdd,afterAdd)" :loading="yt.editObj.loading" size="mini" type="primary">
            {{ $t("baocun") }}
          </el-button>
          <el-button v-if="yt.editObj.action == 'bianji'" @click="yt.req('POST', '/web/tool/adapt/update',beforeAdd,afterAdd)" size="mini" :loading="yt.editObj.loading" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "web_base_tool_tool_adapt_product",
  data() {
    return {
      columns: [
        {
          label: "chanpinbianma",
          prop: "material.code",
          width: 130,
        },
        {
          label: "chanpinmingcheng",
          prop: "material.name",
          width: 130,
        },
        {
          label: "guige",
          prop: "material.spec",
        },
        {
          label: "shipeileixing",
          prop: "adaptType",
          type: "dictionary",
          key: "CUSTOMER_TOOL_ADAPT_TYPE",
        },
        {
          label: "youxianji",
          prop: "sort",
          width: 130,
        },
        {
          label: "caozuo",
          type: "slot",
          width: 150,
          fixed: "right",
        },
      ],
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions.toolId = this.$attrs.tool.id;
      this.yt.conditions.adaptObjectType = 0;
      this.yt.get(1);
    }, 300);
  },
  methods: {
    beforeAdd(params) {
      this.$set(params, 'toolId', this.$attrs.tool.id);
      this.$set(params, 'adaptObjectType', 0);
      return params;
    },
    afterAdd(){
      this.yt.get(1);
      this.yt.isShowEditDialog = false;
    },
  },
}
</script>

<style scoped lang="scss">

</style>